export default function BrowserNotice() {
  const bnClose = $('.js-ie-notice-close')

  const init = () => {
    bnClose.on('click', function () {
      const t = $(this)
      const notice = t.closest('.c-ie-notice')
      notice.css('display', 'none')
    })
  }

  return {
    init: init,
  }
}
